import React from "react";
import { useTranslation } from "react-i18next";
import { motion, useReducedMotion } from "framer-motion";
import { Flag, Layers, Repeat2, Eye, Target, Trophy } from "lucide-react";

const ICONS = [Flag, Layers, Repeat2, Eye, Target, Trophy];

export default function HowToPlay() {
    const reduce = useReducedMotion();
    const { t } = useTranslation();
    const steps = t("howToPlay.steps", { returnObjects: true });
    const safeSteps = Array.isArray(steps) ? steps : [];
    return (
        <section id="how-to-play" className="py-16 sm:py-20 lg:py-24 bg-[#FBF7EE]" data-testid="how-to-play-section">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="flex flex-col items-start gap-4 max-w-2xl">
                    <span className="inline-flex items-center gap-2 rounded-full bg-[#F4EBDD] border border-[#E9D9C1] px-3 py-1 text-xs font-semibold text-[#0B4A34] uppercase tracking-wider">{t("howToPlay.eyebrow")}</span>
                    <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[#062A1E]">{t("howToPlay.title")}</h2>
                    <p className="text-[#1B2621]/75 text-base sm:text-lg">{t("howToPlay.subtitle")}</p>
                </div>
                <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                    {safeSteps.map((s, idx) => {
                        const Icon = ICONS[idx] || Flag;
                        const n = String(idx + 1).padStart(2, "0");
                        return (
                            <motion.div key={idx} initial={reduce ? false : { opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.5, delay: idx * 0.06 }} className="group rounded-2xl border border-[#E9D9C1] bg-[#FFFDF7] p-5 sm:p-6 shadow-[0_10px_30px_rgba(6,42,30,0.06)] hover:shadow-[0_18px_50px_rgba(6,42,30,0.12)] hover:-translate-y-0.5 transition-shadow transition-transform duration-200" data-testid={`howto-step-${n}`}>
                                <div className="flex items-center justify-between">
                                    <span className="font-display text-2xl text-[#C8A24A]">{n}</span>
                                    <span className="inline-flex items-center justify-center h-10 w-10 rounded-xl bg-[#0B4A34] text-[#FBF7EE]"><Icon className="h-5 w-5" /></span>
                                </div>
                                <h3 className="mt-3 text-lg font-semibold text-[#062A1E]">{s.title}</h3>
                                <p className="mt-1.5 text-sm text-[#1B2621]/75 leading-relaxed">{s.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
